import { useTranslation } from 'react-i18next';
import { Button, CustomIcon } from '@components/shared';
import Layout from '../Layout';
import s from './EmptyState.module.less';

type Props = {
  openCreateModal: () => void;
};

const EmptyState = ({ openCreateModal }: Props) => {
  const { t } = useTranslation('tourbook');

  const openCreateTourbook = () => {
    openCreateModal();
  };

  return (
    <Layout containerClassName={s.grid}>
      <div className={s.container}>
        <div className={s.image}>
          <img src="/images/tourbooks.jpg" alt="Tourbooks" />
        </div>
        <div className={s.text}>
          <h2>
            {t('indexEmptyState.tourbooks')} <CustomIcon type="tourbook" className={s.icon} />
          </h2>
          <p>{t('indexEmptyState.valueProp')}</p>
          <ul>
            <li>
              <span>{t('indexEmptyState.shareInfo')}</span>
            </li>
            <li>
              <span>{t('indexEmptyState.remoteTour')}</span>
            </li>
            <li>
              <span>{t('indexEmptyState.customize')}</span>
            </li>
          </ul>
          <div>
            <Button onClick={openCreateTourbook} size="xlarge" data-testid="createTourbook">
              {t('createTourbook')}
            </Button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default EmptyState;
